import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'
import * as colors from '../../../constants/colors'

const ID = 'bluesky-third-party-glyph-icon'

export function BlueSkySymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <path fill={colors.PRIMARY_GREY_000} d="M22.657 18.114c-.185-.02-.37-.045-.553-.074.187.023.371.047.553.074Z" />
        <path d="M16 14.422c-1.449-2.774-5.395-7.944-9.064-10.493C3.422 1.487 2.081 1.909 1.202 2.3.185 2.753 0 4.29 0 5.195c0 .905.504 7.416.832 8.503 1.086 3.592 4.951 4.805 8.51 4.416.183-.027.367-.051.554-.074-.183.029-.368.053-.553.074-5.217.76-9.85 2.631-3.773 9.29 6.683 6.812 9.16-1.46 10.43-5.655 1.27 4.194 2.734 12.168 10.31 5.655 5.69-5.655 1.564-8.53-3.653-9.29-.185-.02-.37-.045-.553-.074.187.023.372.047.553.074 3.56.39 7.425-.824 8.51-4.416.33-1.086.833-7.598.833-8.503 0-.904-.185-2.442-1.202-2.894-.88-.391-2.22-.814-5.734 1.628-3.67 2.55-7.615 7.719-9.064 10.493Z" />
      </g>
    </symbol>
  )
}

const BlueSkyStandaloneContent = standalone(BlueSkySymbol, ID)

export const Bluesky = styled(function BlueSkyStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-bluesky">
      <BlueSkyStandaloneContent />
    </Icon>
  )
})``

export const BlueskyLightweight = styled(function BlueSkyComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-bluesky">
      {lightweight(ID)}
    </Icon>
  )
})``
